export default {
  title: 'Crear mensaje'
}
